import { render, staticRenderFns } from "./DeviceCtrlCompoent.vue?vue&type=template&id=6d83c635&"
import script from "./DeviceCtrlCompoent.vue?vue&type=script&lang=ts&"
export * from "./DeviceCtrlCompoent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports